import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThirdwebProvider, metamaskWallet, walletConnect, phantomWallet, coreWallet, rabbyWallet } from "@thirdweb-dev/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/globals.css";
import "./styles/fonts.css";
import { Avalanche } from "@thirdweb-dev/chains";

// Avalanche mainnet chain ID is 43114
// const activeChainId = 43114; // We'll use the Avalanche object directly

// Create a client
const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThirdwebProvider
        activeChain={{
          ...Avalanche,
          rpc: ["https://api.avax.network/ext/bc/C/rpc", "https://rpc.ankr.com/avalanche"], // Added public RPCs
          // You can add more fallbacks if needed
        }}
        clientId={process.env.REACT_APP_THIRDWEB_CLIENT_ID as string}
        supportedWallets={[
          metamaskWallet(),
          coreWallet(),      // Adding Core Wallet
          rabbyWallet(),      // Adding Rabby Wallet
          phantomWallet(),   // Adding Phantom Wallet
          walletConnect(),
        ]}
      >
        <App />
      </ThirdwebProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
